import type {
	WorkflowItemEdge,
	WorkflowItemNode,
} from "@memorang/types/src/session/new-session";
import {
	type Connection,
	type OnConnect,
	type OnEdgesChange,
	type OnNodesChange,
	addEdge,
	applyEdgeChanges,
	applyNodeChanges,
	reconnectEdge,
} from "@xyflow/react";
import { create } from "zustand";

export type WorkflowState = {
	nodes: WorkflowItemNode[];
	edges: WorkflowItemEdge[];
	onNodesChange: OnNodesChange<WorkflowItemNode>;
	onEdgesChange: OnEdgesChange;
	onConnect: OnConnect;
	setNodes: (nodes: WorkflowItemNode[]) => void;
	setEdges: (edges: WorkflowItemEdge[]) => void;
	onReconnect: (oldEdge: WorkflowItemEdge, newConnection: Connection) => void;
	resetWorkflowStore: () => void;
	addEdge: (edge: WorkflowItemEdge) => void;
};

const useWorkflowStore = create<WorkflowState>((set, get) => ({
	nodes: [],
	edges: [],
	onNodesChange: (changes) => {
		set({
			nodes: applyNodeChanges(changes, get().nodes),
		});
	},
	onEdgesChange: (changes) => {
		set({
			edges: applyEdgeChanges(changes, get().edges),
		});
	},
	onConnect: (connection) => {
		set({
			edges: addEdge(connection, get().edges),
		});
	},
	addEdge: (edge) => {
		set({
			edges: addEdge(edge, get().edges),
		});
	},
	setNodes: (nodes) => {
		set({ nodes });
	},
	setEdges: (edges) => {
		set({ edges });
	},
	onReconnect: (oldEdge, newConnection) => {
		set({
			edges: reconnectEdge(oldEdge, newConnection, get().edges),
		});
	},
	resetWorkflowStore: () => {
		set({
			nodes: [],
			edges: [],
		});
	},
}));

export default useWorkflowStore;
